module.exports = __webpack_public_path__ + "teikeibun.no3.8fb37a00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/teikeibun.no3.jpg
// module id = tgaI
// module chunks = 0